import occupationalHealthEventHandlers from "@/modules/occupational-health/events/event-handlers"
import loginEvents from "@/modules/login/events/events"
import { EventRegister } from "@common/events/event-register"

export const registerEventListeners: EventRegister = (eventBus) => {
  eventBus.$on(loginEvents.LOG_OUT, occupationalHealthEventHandlers.handleLogOutEvent)
}
